export default __webpack_public_path__ + "static/media/ff_fr.b56b04d7.png";